import * as React from 'react';
import { cn } from '../../lib/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'flex h-8 w-full min-w-0 items-center rounded-[var(--ui-radius-control)] border border-[hsl(var(--ui-input))] bg-[hsl(var(--ui-muted))] px-2.5 text-[13px] text-[hsl(var(--ui-foreground))] outline-none transition-[border-color,box-shadow] placeholder:text-[hsl(var(--ui-muted-foreground))] focus-visible:border-[hsl(var(--ui-ring))] focus-visible:ring-2 focus-visible:ring-[hsl(var(--ui-ring)/0.22)]',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';
